import AboutEt from "../layout/home/AboutEt";
import FAQ from "../layout/home/FAQ";
import FlippableSection from "../layout/home/FlipSection";
import HeroSection from "../layout/home/hero/Hero";
import TwinBots from "../layout/home/twinSlider/TwinBots";
import Container from "../shared/Container";
import Layout from "../shared/Layout";

// Code for session
import {
  sessionTimeOutCheck,
  checkExpiry,
} from "../../redux/global/actions.js";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import endpoints from "../../utility/endpoints";
import axios from "axios";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

const HomePage = (props) => {
  //code for session
  const router = useRouter();
  const currentUrl = router.asPath;
  const [successModal1, setSuccessModal1] = useState(false);
  const checkAuthorization = async () => {
    let authData = JSON.parse(localStorage.getItem("auth"));
    if (!authData || !authData.data) {
      // Handle the case when authData or authData.data is falsy
      props.sessionTimeOutCheck(true);

      localStorage.setItem("redirectprofileurl", JSON.stringify(currentUrl));
      return; // Return without making the API call
    }
    try {
      let auth = JSON.parse(localStorage.getItem("auth")).data;
      const { data } = await axios({
        method: "GET",
        url: `${endpoints.baseUrl}/roi/checkAuthorization`,
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
      });
      console.log("checkAuthorization", data);
      if (data.data.code === 200) {
        console.log("Authorized User", data.data);
      } else if (data.code === 403) {
        setTimeout(() => {
          props.sessionTimeOutCheck(true);
        }, 1000);
        console.log("Error in authorization", data);
        localStorage.setItem("redirectprofileurl", JSON.stringify(currentUrl));
      } else {
        props.sessionTimeOutCheck(true);
        localStorage.setItem("redirectprofileurl", JSON.stringify(currentUrl));
      }
    } catch (error) {
      console.log("Error in Authorization", error);
    }
  };
  useEffect(() => {
    checkAuthorization();
  }, []);

  return (
    <>
      <Layout>
        <HeroSection />
        <AboutEt />
        <div className="py-10  bg-white relative">
          <Container>
            <FlippableSection />
          </Container>
        </div>
        <TwinBots />
        <FAQ />
      </Layout>
    </>
  );
};

//code for session
const mapStateToProps = (state) => {
  console.log("state", state);
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);

